import angular from 'angular';

import '../resources/slot-per-time-range';

const module = angular.module('whyline.services.slotsPerTimeRange', [
  'whyline.resources.slotsPerTimeRange',
]);


let SlotPerTimeRange;

class SlotsPerTimeRangeService {

  static $inject = ['SlotsPerTimeRange'];

  constructor(injectedSlotsPerTimeRange) {
    /*@ngInject*/
    SlotPerTimeRange = injectedSlotsPerTimeRange;
  }

  Create(data) {
    const newSlotPerTimeRange = new SlotPerTimeRange(data);
    return SlotPerTimeRange.Save(newSlotPerTimeRange);
  }

  Remove(id) {
    return SlotPerTimeRange.DeleteConfig(id);
  }

  GetByFilter(filter) {
    return SlotPerTimeRange.GetByFilter(filter);
  }

  GetDateWithTimezone(date, time, offset) {
    const dateString = new Date(date).toISOString().substring(0, new Date(date).toISOString().indexOf('T'));
    const dateWithTime = dateString + 'T' + time+ ':00' + offset;
    return dateWithTime;
  }

}

module.exports = module.service('SlotsPerTimeRangeService', SlotsPerTimeRangeService);
